import { application } from './application';

import AddressAutocompleteController from './address_autocomplete_controller'
import TomSelectController from './tom_select_controller'
import FormController from './form_controller'
import ConfirmModalController from './confirm_modal_controller'
import ModalController from './modal_controller'
import IbanChannelController from './iban_channel_controller'
import PopoverController from './popover_controller'
import CarouselStimulusController from './carousel_stimulus_controller'
import LemonwayIframeController from './lemonway_iframe_controller'
import FlatpickrController from './flatpickr_controller'
import ClipboardController from './clipboard_controller'
import PasswordVisibilityController from './password_visibility_controller'
import KycFileFeedbackController from './kyc_file_feedback_controller'
import KycFileBackSelectionMenuController from './kyc_file_back_selection_menu_controller'
import ExpressionInvestFormController from './expression_invest_form_controller'

application.register('address-autocomplete', AddressAutocompleteController)
application.register('tom-select', TomSelectController)
application.register('form', FormController)
application.register('confirm-modal', ConfirmModalController)
application.register('modal', ModalController)
application.register('iban-channel', IbanChannelController)
application.register('popover', PopoverController)
application.register('carousel-stimulus', CarouselStimulusController)
application.register('lemonway-iframe', LemonwayIframeController)
application.register('flatpickr', FlatpickrController)
application.register('clipboard', ClipboardController)
application.register('password-visibility', PasswordVisibilityController)
application.register('kyc-file-feedback', KycFileFeedbackController)
application.register('kyc-file-back-selection-menu', KycFileBackSelectionMenuController)
application.register('expression-invest-form', ExpressionInvestFormController)
